// Structuurrelaties van een hexagram, klassiek: 錯 cuo (tegenhanger), 綜 zong (omgekeerd),
// 交 jiao (gewisseld), 互 hu (kern), 八宮 (paleis van Jing Fang). Figuur = 6 bits onder→boven.
import { hexagramBits, hexagramNumber, nuclearHexagram, resonanceTrigram, trigramsOf } from './iching-core';
import { ICHING_PALACES } from './iching-palaces.const';
import { IChingFigure, IChingPalace, IChingRelations, IChingTrigramId } from './iching.models';

function numberOf(figure: IChingFigure): number {
  const { lower, upper } = trigramsOf(figure);
  return hexagramNumber(upper, lower);
}

/** 錯 cuo: elke lijn omgekeerd. */
export function oppositeHexagram(figure: IChingFigure): number {
  return numberOf(
    figure
      .split('')
      .map(b => (b === '1' ? '0' : '1'))
      .join(''),
  );
}

/** 綜 zong: de figuur op zijn kop. */
export function invertedHexagram(figure: IChingFigure): number {
  return numberOf(figure.split('').reverse().join(''));
}

/** 交 jiao: onderste en bovenste trigram gewisseld. */
export function exchangedHexagram(figure: IChingFigure): number {
  return numberOf(figure.slice(3) + figure.slice(0, 3));
}

/** King Wen-paar: omgekeerd, of tegenhanger als de figuur symmetrisch is. */
export function kingWenPartner(number: number): number {
  const figure = hexagramBits(number);
  const inverted = invertedHexagram(figure);
  return inverted === number ? oppositeHexagram(figure) : inverted;
}

/** Paleis (八宮) waarin het hexagram staat. */
export function palaceOf(number: number): IChingPalace {
  for (const palace of ICHING_PALACES) {
    const position = palace.members.indexOf(number);
    if (position >= 0) {
      return { trigram: palace.trigram, members: palace.members, position };
    }
  }
  throw new Error(`Geen paleis voor hexagram ${number}`);
}

export function relationsOf(number: number): IChingRelations {
  const figure = hexagramBits(number);
  return {
    number,
    opposite: oppositeHexagram(figure),
    inverted: invertedHexagram(figure),
    exchanged: exchangedHexagram(figure),
    nuclear: nuclearHexagram(figure),
    kingWenPartner: kingWenPartner(number),
    palace: palaceOf(number),
  };
}

/**
 * Resonantietrigram van twee figuren (twee personen): per lijn verschil = yang,
 * gelijk = yin; op die verschilfiguur de resonantieregel van de gids
 * (lijnparen 1-4, 2-5, 3-6). Gelijke figuren geven Kun.
 */
export function pairResonanceTrigram(a: IChingFigure, b: IChingFigure): IChingTrigramId {
  const difference = [0, 1, 2, 3, 4, 5].map(i => (a[i] === b[i] ? '0' : '1')).join('');
  return resonanceTrigram(difference);
}
